import React, { useState } from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { media } from '../../../utils/media-queries';
import CtaLink from '../../atoms/ctaLink';

export const Shortcut = ({ imageSrc, alt, pageLink, ctaText }) => {
  const [hover, setHover] = useState();

  return (
    <>
      <Link
        to={`/${pageLink}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setTimeout(() => setHover(false), 2000)}
      >
        <Img fluid={imageSrc} alt={alt} />
      </Link>
      <CtaLink link={pageLink} ctaText={ctaText} active={hover} />
    </>
  );
};

const Shortcuts = ({
  firstImageSrc,
  firstImageAlt,
  firstPageLink,
  firstCtaText,
  secondImageSrc,
  secondImageAlt,
  secondPageLink,
  secondCtaText,
}) => (
  <StyledShortcuts className="grid">
    <p className="overline">Shortcuts</p>
    <div className="first-shortcut">
      <Shortcut
        imageSrc={firstImageSrc}
        alt={firstImageAlt}
        pageLink={firstPageLink}
        ctaText={firstCtaText}
      />
    </div>
    <div className="second-shortcut">
      <Shortcut
        imageSrc={secondImageSrc}
        alt={secondImageAlt}
        pageLink={secondPageLink}
        ctaText={secondCtaText}
      />
    </div>
  </StyledShortcuts>
);

const StyledShortcuts = styled.section`
  margin-bottom: calc(var(--v-spacing-L) * 3);
  .gatsby-image-wrapper {
    height: 40vw;
  }

  .first-shortcut {
    grid-column: 1 / 13;
  }

  .second-shortcut {
    grid-column: 13 / 25;
  }

  .link {
    padding-top: var(--spacing-XXS);
  }

  @media ${media.L} {
    .gatsby-image-wrapper {
      height: 22vw;
    }

    .first-shortcut {
      grid-column: 1 / 7;
    }

    .second-shortcut {
      grid-column: 7 / 13;
    }
  }
`;

Shortcuts.propTypes = {
  firstImageSrc: PropTypes.object,
  firstImageAlt: PropTypes.string,
  secondImageSrc: PropTypes.object,
  secondImageAlt: PropTypes.string,
  firstCtaText: PropTypes.string,
  firstPageLink: PropTypes.string,
  secondCtaText: PropTypes.string,
  secondPageLink: PropTypes.string,
};

Shortcut.propTypes = {
  imageSrc: PropTypes.object,
  alt: PropTypes.string,
  pageLink: PropTypes.string,
  ctaText: PropTypes.string,
};

export default Shortcuts;
